import {useGet} from "@hooks/http.ts";
import {useCallback} from "react";
import {useOnce} from "@hooks/once.ts";
import {ApiTokenRelevant, ApiTokenPairRelevantList, ApiTokenPairRelevant} from "@api";

type TokenRelevantListAction = (abortController?: AbortController) => void;
export const useTokenPairRelevantList = (): readonly [
        Array<ApiTokenPairRelevant> | undefined,
    boolean,
        Error | undefined,
    TokenRelevantListAction
] => {
    const [response, loading, error, get] = useGet<ApiTokenPairRelevantList>();

    const fetchTokenRelevants = useCallback((abortController?: AbortController) => {
        console.trace("fetching speed dials");
        get(`/v1/token-pairs?query=RELEVANT`, abortController);
    }, [get]);

    useOnce(() => {
        fetchTokenRelevants()
    }, [fetchTokenRelevants]);

    return [response?.pairs, loading, error, fetchTokenRelevants] as const;
}